<div class="groups" [formGroup]="group()">
    @for (engine of engines(); track engine) {
        <fieldset class="group">
            <legend>{{ "FLIGHT_LIST.groups.engine" + engine | translate }}</legend>
            <div class="fields triple">
                @for (reading of readings; track reading) {
                    <label class="field">
                        <span class="label">{{ "FLIGHT_LIST.reading" + reading | translate }}</span>
                        <kendo-numerictextbox
                            [formControlName]="'engine' + engine + 'Actual' + reading"
                            format="#.##"
                            [decimals]="2"
                            [min]="0"
                            [spinners]="false"
                        ></kendo-numerictextbox>
                    </label>
                }
            </div>
        </fieldset>
    }
</div>
